export const TWO_FACTOR_AUTH_TAGS = {
    login: 'uam/2fa/login2FAEnabled',
    changePassword: 'uam/2fa/changePassword2FAEnabled',
    changePin: 'uam/2fa/changePIN2FAEnabled',
    changeEmail: 'uam/2fa/changeEmail2FAEnabled',
    changeMobile: 'uam/2fa/changePhone2FAEnabled',
    changePlayer: 'uam/2fa/changePlayer2FAEnabled',
    unblockAccount: 'uam/2fa/unblockAccount2FAEnabled',
    channel: 'uam/2fa/2FAChannel',
    notifications: 'uam/2fa/2FANotificationMessages',
    withdrawal: 'uam/2fa/withdraw2FAEnabled'
};

export const SERVICE_TO_TAG_MAP = {
    login: { service: 'LOGIN', tag: 'login2FAEnabled' },
    changePassword: { service: 'CHANGE_PASSWORD', tag: 'changePassword2FAEnabled' },
    changePin: { service: 'CHANGE_PIN', tag: 'changePIN2FAEnabled' },
    changeEmail: { service: 'CHANGE_EMAIL', tag: 'changeEmail2FAEnabled' },
    changeMobile: { service: 'CHANGE_MOBILE', tag: 'changePhone2FAEnabled' },
    changePlayer: { service: 'CHANGE_PLAYER', tag: 'changePlayer2FAEnabled' },
    unblockAccount: { service: 'UNBLOCK_ACCOUNT', tag: 'unblockAccount2FAEnabled' },
    withdrawal: { service: 'WITHDRAW', tag: 'withdraw2FAEnabled' }
};
